export default {
  'message.successSave': '{{entity}} успешно создан',
  'message.successUpdate': '{{entity}} успешно обновлён',
  'message.errorSave': 'Ошибка при создании {{entity}}',
  'message.errorUpdate': 'Ошибка при обновлении {{entity}}',
  'message.errorGet': 'Не удалось получить {{entity}}',
  'message.errorDownload': 'Ошибка загрузки файла',
  'message.successDelete': '{{entity}} успешно удалён',
  'message.errorDelete': 'Не удалось удалить {{entity}}',
  'message.successSentVerificationEmail':
    'Письмо с подтверждением успешно отправлено',
  'message.pendingEmailVerification': 'Ожидание подтверждения email',
  'message.errorSentVerificationEmail':
    'Ошибка отправки письма с подтверждением',
  'message.delete.explain': '{{entity}} помечен как удалённый',
  'message.delete.info': 'Удаление доступно только в режиме редактирования',
  'message.deactivate.info': 'Деактивировать {{entity}}',
  'message.delete.warning': 'Вы уверены, что хотите удалить этот {{entity}}?',
  'message.deactivate.warning':
    'Вы уверены, что хотите удалить {{entity}}? Сначала он будет помечен как деактивированный.',
  'message.delete.confirm':
    'При подтверждении удаления система выполнит действие. {{entity}} может быть удалён из базы данных.',
  'message.inactive.confirm':
    'Сущность будет помечена как неактивная. Она больше не будет видна или доступна, но не удалится.',
  'message.unassigned.warning':
    'Вы абсолютно уверены, что хотите снять это назначение {{entity}}?',
  'message.unassigned.confirm':
    'При подтверждении система удалит назначение {{entity}} из базы данных.',
  'message.unload.title': 'Несохранённые изменения',
  'message.unload.description':
    'У вас есть несохранённые изменения. Вы уверены, что хотите покинуть эту страницу?',
};
